exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quill-editor.is-invalid[data-v-50b85ad2], .vdp-datepicker.is-invalid[data-v-50b85ad2] {\n  border:1px solid #f05050\n}\n", ""]);

// exports
